import React from 'react';
import { Vec2, vec2 } from 'utility/gl-matrix';
import MultiplatformComponent from 'components/MultiplatformComponent';

interface Props {
  children: (viewportDimensions: Vec2) => JSX.Element | null;
}

function WebViewportResponder(props: Props) {
  const [dimensions, setDimensions] =
    React.useState<Vec2>([window.innerWidth, window.innerHeight]);

  React.useEffect(() => {
    const onResize = () => {
      const newDimensions = vec2.fromValues(document.documentElement.clientWidth, document.documentElement.clientHeight);
      if (!vec2.equals(newDimensions, dimensions)) {
        setDimensions(newDimensions);
      }
    };
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return props.children(dimensions);
}

const ViewportResponder = MultiplatformComponent({
  web: WebViewportResponder,
});

export default ViewportResponder;
